import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "disabled"]
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["points"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["w-full h-full flex items-center justify-center transition-opacity focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-1 rounded disabled:opacity-50 disabled:cursor-default", _ctx.data.length ? 'cursor-pointer hover:opacity-80' : '']),
    title: _ctx.data.length ? 'Click to view detailed trend' : '',
    disabled: !_ctx.data.length,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    (_openBlock(), _createElementBlock("svg", {
      width: _ctx.width,
      height: _ctx.height,
      class: "block text-violet-500 pointer-events-none",
      preserveAspectRatio: "none"
    }, [
      _createElementVNode("polyline", {
        points: _ctx.pathPoints,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2))
  ], 10, _hoisted_1))
}